var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 7C4.72386 7 4.5 7.22386 4.5 7.5C4.5 7.77614 4.72386 8 5 8H6C6.27614 8 6.5 7.77614 6.5 7.5C6.5 7.22386 6.27614 7 6 7H5Z",
    fill: "#8E97A3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 2V4H16C17.6569 4 19 5.34315 19 7V13C19 14.6569 17.6569 16 16 16H15V18C15 18.5523 14.5523 19 14 19H6C5.44772 19 5 18.5523 5 18V16H4C2.34315 16 1 14.6569 1 13V7C1 5.34315 2.34315 4 4 4H5V2C5 1.44772 5.44772 1 6 1H14C14.5523 1 15 1.44772 15 2ZM6.5 4V2.5H13.5V4H6.5ZM16 14.5H15V11C15 10.4477 14.5523 10 14 10H6C5.44772 10 5 10.4477 5 11V14.5H4C3.17157 14.5 2.5 13.8284 2.5 13V7C2.5 6.17157 3.17157 5.5 4 5.5H16C16.8284 5.5 17.5 6.17157 17.5 7V13C17.5 13.8284 16.8284 14.5 16 14.5ZM6.5 11.5H13.5V17.5H6.5V11.5Z",
    fill: "#8E97A3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 15.75C8 15.4739 8.22386 15.25 8.5 15.25H11.5C11.7761 15.25 12 15.4739 12 15.75C12 16.0261 11.7761 16.25 11.5 16.25H8.5C8.22386 16.25 8 16.0261 8 15.75Z",
    fill: "#8E97A3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 12.75C8.22386 12.75 8 12.9739 8 13.25C8 13.5261 8.22386 13.75 8.5 13.75H11.5C11.7761 13.75 12 13.5261 12 13.25C12 12.9739 11.7761 12.75 11.5 12.75H8.5Z",
    fill: "#8E97A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.bbd36899c0fd9125448a6097014d154e.svg";
export { ForwardRef as ReactComponent };